import { useSelector } from 'react-redux';
import {TRAFFIC_SUB_VIEW_MODEL} from "../../Model/Model";
import {MODELS} from "../../../../../Apis/Models";
import {TABLES} from "../../../../../Apis/Tables";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ManageMainApp = ({ setSubView, setModuleId, setOption, setSearch, setSearchElement }) => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const handleSubViewChange = (view) => {
        if(view === TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.DASHBOARD){
            setModuleId(MODELS.TRAFFIC_DASHBOARD_FINES);
            setOption(TABLES.FINE);
            setSearch(true);
        }else if(view === TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.USERS){
            setModuleId(MODELS.TRAFFIC_USERS);
            setOption(TABLES.FINE_USER);
            setSearch(false);
        }
        setSubView(view);
        setSearchElement("")
    };

    return {
        DEV,
        permission,
        handleSubViewChange
    };
};

export default ManageMainApp;
